import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { GraduatedReview } from "./GraduatedReviewModels";

export interface GraduatedJustificationDialogProps {
    header: string;
    message: string;
    style?: React.CSSProperties;
    visible: boolean;
    onHide: () => void;
    isReadOnly: boolean;
    reasons: any[];
    selectedReasonIds: any[];
    userReason: string;
    onReasonChange: (e: any) => void;
    onUserReasonChange: (val: string) => void;
    onSave?: () => void;
    loading?: boolean;
    graduatedMeasureReviews?: GraduatedReview[] | null;
    desiredTier?: string;
    graduatedTiers?: any[] | null;
}

export default function GraduatedJustificationDialog({
    header,
    message,
    style,
    visible,
    onHide,
    isReadOnly,
    reasons,
    selectedReasonIds,
    //userReason,
    //onReasonChange,
    //onUserReasonChange,
    onSave,
    loading = false,
    graduatedMeasureReviews=null,
    graduatedTiers,
    desiredTier
}: GraduatedJustificationDialogProps) {
return (
    //handle this popup properly
    <Dialog
        
         header={header} visible={visible} style={style} onHide={onHide}>
            <div style={{ marginBottom: '1rem' }}>
                <strong>Desired Tier:</strong> {desiredTier}
            </div>
            <p className="m-0">{message}</p>
        <Divider />
        {loading ? (
            <div style={{ color: 'gray', marginBottom: '1rem' }}>
                Loading failed reasons...
            </div>
        ) : !reasons || reasons.length === 0 ? (
            <div style={{ color: 'gray', marginBottom: '1rem' }}>
                No failed reasons available for this measure.
            </div>
        ) : (
            reasons.filter(x => x && selectedReasonIds?.includes(x.reasonId)).map((reason: any) => (
                <div key={reason.reasonId} className="flex align-items-center">
                <li style={{ listStyleType: 'disc', marginLeft: '1rem' }}>
                    {reason.reasonText || ''}
                </li>
                </div>
            ))
        )}
        <br />

        {graduatedMeasureReviews && graduatedMeasureReviews.length > 0 && (() => {
            // Sort reviews: NA (Not Approved) first, then A (Approved)
            const sortedReviews = [...graduatedMeasureReviews].sort((a, b) => {
                const aResponse = a?.reviewResponse?.toLowerCase() || '';
                const bResponse = b?.reviewResponse?.toLowerCase() || '';
                if (aResponse === 'na' && bResponse === 'a') return -1;
                if (aResponse === 'a' && bResponse === 'na') return 1;
                return 0;
            });

            return (
                <>
                    <Divider />
                    <h3 style={{ marginBottom: '1rem' }}>Graduated Scoring Outcomes</h3>
                    {sortedReviews.map((review, index) => {
                        if (!review) return null;
                        
                        const tier = graduatedTiers?.find((t: any) => 
                            t && (t.tierId === review.graduateTierId
                                && t.measureId===review.graduateMeasureId
                            )
                        );
                        const tierName = tier?.tierName || tier?.name || 'Unknown';
                        const measureNumber = tier?.measureNumber || '';
                        const reviewResponseLower = review.reviewResponse?.toLowerCase() || '';
                        
                        return (
                            <div key={index} style={{ marginBottom: '1rem' }}>
                                <strong>{tierName}{measureNumber ? ` (${measureNumber})` : ''}</strong>
                                {reviewResponseLower === 'na' && review.reviewDetails?.reasons && review.reviewDetails.reasons.length > 0 ? (
                                    <div>
                                        <p style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                                            The measure was marked as "Not Approved" for the following reasons:
                                        </p>
                                        {review.reviewDetails.reasons.map((reason) => (
                                            reason && (
                                                <div key={reason.reasonId} className="flex align-items-center">
                                                    <li style={{ listStyleType: 'disc', marginLeft: '1rem' }}>
                                                        {reason.reasonText || ''}
                                                    </li>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                ) : reviewResponseLower === 'a' ? (
                                    <div style={{ marginTop: '0.5rem', color: 'green' }}>
                                        <p>The measure was marked as "Approved"</p>
                                    </div>
                                ) : null}
                            </div>
                        );
                    })}
                </>
            );
        })()}

        {/* <InputTextarea
            value={userReason}
            onChange={(e) => !isReadOnly && onUserReasonChange(e.target.value)}
            autoResize
            rows={5}
            cols={70}
            disabled={isReadOnly}
        /> */}
        <Divider />
        <div style={{ display: 'flex', justifyContent: "space-between" }}>
            <Button onClick={onSave} disabled={isReadOnly}>Edit</Button>
            <Button
                onClick={onHide}
                disabled={isReadOnly || !selectedReasonIds || selectedReasonIds.length === 0}
            >
                Ok
            </Button>
        </div>
    </Dialog>
);
}